import React from "react";
import { ExternalLink, MapPin } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
interface LocationItem {
  name: string;
  sublabel: string;
  address: string;
  mapEmbedUrl: string;
  directionsUrl: string;
}
const locations: LocationItem[] = [{
  name: "Delray Beach Office",
  sublabel: "Suite 301 · Medical Plaza",
  address: "5210 Linton Blvd Suite 301, Delray Beach FL 33484",
  mapEmbedUrl: "https://www.google.com/maps?q=5210+Linton+Blvd+Suite+301+Delray+Beach+FL+33484&output=embed",
  directionsUrl: "https://www.google.com/maps?q=5210+Linton+Blvd+Suite+301+Delray+Beach+FL+33484"
}, {
  name: "Boynton Beach Office",
  sublabel: "Suite 100 · Enterprise Center",
  address: "10151 Enterprise Center Blvd Suite 100, Boynton Beach FL 33437",
  mapEmbedUrl: "https://www.google.com/maps?q=10151+Enterprise+Center+Blvd+Suite+100+Boynton+Beach+FL+33437&output=embed",
  directionsUrl: "https://www.google.com/maps?q=10151+Enterprise+Center+Blvd+Suite+100+Boynton+Beach+FL+33437"
}];
export default function ClinicalLocationMap() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  return <section id="clinicallocationmap" className="relative w-full overflow-hidden border-y border-border bg-white py-16 sm:py-20">
      <div ref={ref} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" style={{
      opacity: isVisible ? 1 : 0,
      transform: isVisible ? "translateY(0)" : "translateY(20px)",
      transition: "opacity 400ms ease-out, transform 400ms ease-out"
    }}>
        <div className="mb-12 text-center">
          <p className="mb-2 font-mono text-xs font-semibold uppercase tracking-[0.18em] text-[#A32D2D]">
            Our Locations
          </p>
          <h2 className="font-serif text-3xl font-semibold tracking-[-0.02em] text-[#152238] md:text-4xl">
            Delray Beach &amp; Boynton Beach
          </h2>
          <div className="mx-auto mt-3 h-[3px] w-10 rounded-full bg-primary" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {locations.map((loc, index) => <div key={loc.name} data-index={index} className="flex flex-col overflow-hidden rounded-lg border border-border bg-[#f7f8fa] p-6 shadow-none transition-shadow duration-300 hover:shadow-md">
              <div className="h-64 w-full overflow-hidden rounded-md border border-border bg-[#f7f8fa]">
                <iframe title={`${loc.name} map`} src={loc.mapEmbedUrl} className="h-full w-full grayscale-[0.35] contrast-90 brightness-105" style={{
              border: 0
            }} loading="lazy" allowFullScreen />
              </div>

              <div className="mt-4 flex flex-1 flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2">
                    <MapPin className="h-4 w-4 text-primary shrink-0" />
                    <h3 className="text-lg font-semibold text-[#152238]">
                      {loc.name}
                    </h3>
                  </div>
                  <p className="text-xs font-medium text-muted-foreground mt-0.5">
                    {loc.sublabel}
                  </p>
                  <p className="mt-2 text-sm text-[#152238]">{loc.address}</p>
                </div>

                <div className="mt-4 pt-4 border-t border-border">
                  <Link to={loc.directionsUrl} newTab className="inline-flex items-center gap-1.5 text-sm font-semibold text-primary transition-colors hover:underline">
                    <span>Get directions</span>
                    <ExternalLink className="h-3.5 w-3.5" />
                  </Link>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}
